<template>
  <div class="service-page">
    <!-- Fixed Header -->
    <header class="fixed-header">
      <div class="header-content">
        <div class="back-button" @click="goBack">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="#333"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h1 class="header-title">Service</h1>
        <div class="header-placeholder" />
      </div>
    </header>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Tabs -->
      <!-- <div class="tabs-container">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          class="tab"
          :class="{ active: activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          {{ tab.name }}
        </div>
      </div> -->

      <!-- Form Section -->
      <div class="form-section">
        <div class="input-group">
          <input
            v-model="params.email"
            type="email"
            class="input-field"
            placeholder="Please enter your email"
          >
        </div>

        <div class="input-group">
          <input
            v-model="params.userid"
            type="text"
            class="input-field"
            placeholder="Please enter your user ID"
          >
        </div>

        <div class="input-group">
          <input
            v-model="params.orderNum"
            type="text"
            class="input-field"
            placeholder="Please enter your order number"
          >
        </div>

        <button
          class="submit-button"
          :disabled="!canSubmit"
          @click="handleSubmit"
        >
          Unsubscribe
        </button>
      </div>

      <!-- Disclaimer -->
      <div class="disclaimer">
        <p>
          *After unsubscribing, you will no longer have access to MakoNovel
          premium benefits or be eligible to receive gift cards.
        </p>
      </div>

      <!-- Footer -->
      <div class="footer">
        <div class="contact-info">
          <p class="contact-label">
            If you have any questions, please contact us:
          </p>
          <p class="contact-email">magicubegroup@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MerchantAgreementTermination',
  data() {
    return {
      activeTab: 'unsubscribe',
      tabs: [
        { id: 'unsubscribe', name: 'Email' },
        { id: 'service', name: 'Order Number' },
      ],
      params: {
        email: '',
        userid: '',
        orderNum: '',
      },

    }
  },
  computed: {
    canSubmit() {
      return (
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.params.email.trim(),
        ) && this.params.userid.trim() !== '' && this.params.orderNum.trim() !== ''
      )
    },
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    handleSubmit() {
      axios.post('https://api.cubetv.cc/h5/user/unsubscribe', this.params).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          console.log(res)
          alert(res.data.data.msg)
        }
      }).catch(err => {
        alert(err.msg || err.message)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.service-page {
  min-height: 100vh;
  background-color: #fff;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  background-color: #fff;
  z-index: 100;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 768px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.back-button {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Segoe UI',
    Roboto, Arial, sans-serif;
}

.header-placeholder {
  width: 44px;
  flex-shrink: 0;
}

.main-content {
  padding-top: 54px;
  padding-bottom: 20px;
  max-width: 768px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

.tabs-container {
  display: flex;
  background-color: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 25px;
  overflow: hidden;
}

.tab {
  flex: 1;
  padding: 12px 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f0f0f0;
}

.tab.active {
  background-color: #ff1979;
  color: #fff;
}

.form-section {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 25px;
}

.input-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
}

.input-field {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  transition: border-color 0.3s ease;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #ff1979;
  }
}

.submit-button {
  width: 100%;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #1a1a1a;
  }
}

.disclaimer {
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 25px;
}

.footer {
  border-top: 1px solid #f0f0f0;
  margin-top: 40px;
  padding-top: 20px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.contact-label {
  color: #999;
  font-size: 14px;
}

.contact-email {
  color: #ff1979;
  font-size: 14px;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .main-content {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
